import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { ieCheck } from '../../helpers/utils';
import { checkArrayItemExist } from '../../helpers/arrayUtils';
import _filter from 'lodash/filter';
import StopButton from './stops-button';
import ReactModal from 'react-modal';
import { calculateAccommodationPrice } from '../../helpers/priceHelper';
import { bindActionCreators } from 'redux';
import { DeleteTrip } from '../../actions/booking';
import { RemoveTripPayload } from '../../helpers/bookingHelper';
import Spinner from '../shared/spinner';
import { CYOA_NETWORK_IDS } from '../../config';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);


class SummaryItem extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      isCYOA:checkArrayItemExist(props.data.tour_id, [ CYOA_NETWORK_IDS["europe"].id, CYOA_NETWORK_IDS["usa"].id ]) ? true : false,
      discountTooltipIsOpen:false,
      showStopsModal:false
    }
    this.discountClick = this.discountClick.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.openStopsModal = this.openStopsModal.bind(this);
    this.closeStopsModal = this.closeStopsModal.bind(this);
    this.onRemoveTrip = this.onRemoveTrip.bind(this);
  }

  onRemoveTrip(){

    const { DeleteTrip, bookingGroup, id } = this.props;

    //Delete trip bundle trip
    const payload = RemoveTripPayload(bookingGroup, id);
    DeleteTrip(bookingGroup, payload);

  }

  closeStopsModal(){ this.setState({showStopsModal:false}); }
  openStopsModal(){
    this.setState({showStopsModal:true});
  }

  componentDidMount(){
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "columns trips-box small-12 medium-4 large-4"){
        if(this.state.discountTooltipIsOpen) this.setState({discountTooltipIsOpen: false});
      }
    }catch(e){}
  }

  //Trip - Original price before discount (price + discount)
  calculatePrice(arr){
    let _price = 0;
    let _discount = 0;
    let _total = 0;
    for(let i = 0; i < arr.length; i++){
      _price += arr[i].price;
      _discount += arr[i].discount;
    }

    _total = _price + _discount;

    return _total.toFixed(2);
  }
  //Discount - all discounts
  calculateDiscount(arr){
    let _discount = 0;
    for(let i = 0; i < arr.length; i++){
      _discount += arr[i].discount;
    }
    return _discount.toFixed(2);
  }
  //Total - Original price less the discount price
  calculateTotal(arr){

    const _itinerarySectors = (this.props.itineraries !== undefined) ? this.props.itineraries.sectors :  [];
    const _accommodationPrice = parseFloat(calculateAccommodationPrice(_itinerarySectors));

    let _outstanding = 0;

    for(let i = 0; i < arr.passengers.length; i++){
      _outstanding += arr.passengers[i].price;
    }

    if(arr.tour_id === CYOA_NETWORK_IDS["europe"].id || arr.tour_id === CYOA_NETWORK_IDS["usa"].id ){
      return (_outstanding + _accommodationPrice).toFixed(2);
    }else{
      return _outstanding.toFixed(2);
    }

  }

  calculatePassengers(arr){
    let _adults = 0;

    for(let i = 0; i < arr.length; i++){
      if(arr[i].age_category === "Adult"){
        _adults += 1;
      }
    }
    if(_adults !== 0) return _adults + " Adults";

  }


  calculateArrival(departure, duration){
    return dayjs(departure).add(duration-1, 'days').format("Do MMMM YYYY");
  }

  calcuateTime(time){
    return time !== undefined ? time.substring(0, time.lastIndexOf(":")) : "";
  }

  discountClick(){
    this.setState({discountTooltipIsOpen: !this.state.discountTooltipIsOpen});
  }

  discountMsg(arr){
    return (arr[0].discount_description !== null) ? arr[0].discount_description : "";
  }

  renderStandardDescription(props){

    //check product type is fixed or hoho
    const tourData =  _filter(props.product, ['tourId', props.data.tour_id ]).length > 0 ? _filter(props.product, ['tourId', props.data.tour_id ])[0] : props.product[0];
    
    if(tourData !== undefined){
      return (
          <div className="row">
            <div className="column small-12 medium-6 description-box-item">
              <p className="bold">Start:</p>
              <p>{ dayjs(props.data.departure_date).format("Do MMMM YYYY") } at {this.calcuateTime(tourData.startTime)}

              </p>
              <p className="grey-text" style={{display:tourData.type === 'hoho' ? 'none' : 'block'}}>at {tourData.startDescription}, {(tourData.locations !== undefined) ? tourData.locations[0].name : ""  }</p>
            </div>
            <div className="column small-12 medium-6 description-box-item">
              <p className="bold">End:</p>
              <p style={{visibility:tourData.type === 'hoho' ? 'hidden' : 'visible'}}>{ this.calculateArrival(dayjs(props.data.departure_date).format("YYYY-MM-DD"), tourData.duration) } at {this.calcuateTime(tourData.endTime)}</p>
              <p className="grey-text" style={{display:tourData.type === 'hoho' ? 'none' : 'block'}}>at {tourData.endDescription}, {(tourData.locations !== undefined) ? tourData.locations[1].name : "" }</p>
            </div>
            <div className="column small-12 medium-6 description-box-item">
              <p className="bold">Duration:</p>
              <p>{tourData.duration} days</p>
            </div>
            <div className="column small-12 medium-6 description-box-item">
              <p className="bold">Passengers:</p>
              <p>{ this.calculatePassengers(props.clients) }</p>
            </div>
          </div>
      )
    }
  }

  renderCyoaDescription(props){

    const _itineraries = (props.itineraries !== undefined) ? props.itineraries : "";
    const _numDays = (_itineraries !== "") ? _itineraries.content.nr_nights : "";
    const _accommodationNightsArr = (_itineraries !== "") ? _itineraries.sectors.map(item => { return item.accommodation }) : [];

    let _num_nights = 0;
    for(let i=0; i < _accommodationNightsArr.length; i++){
      if(_accommodationNightsArr[i].bookings !== undefined){
        if(_accommodationNightsArr[i].bookings.total !== "0.00"){
          _num_nights += _accommodationNightsArr[i].bookings.nights || 0;
        }
      }
    }

    const start_date = (_itineraries !== "" && _itineraries.content.date_start !== undefined ) ? dayjs(_itineraries.content.date_start).format("Do MMMM YYYY") : "";
    const end_date = (_itineraries !== "" && _itineraries.content.date_end !== undefined ) ? dayjs(_itineraries.content.date_end).format("Do MMMM YYYY") : "";


    return (
      <div className="row">
        <div className="column small-12 medium-7 description-box-item cyoa">
          <ul>
            <li>
              <p className="title">{props.data.passengers[0].reservations[0].start_city}</p>
              <p className="subtitle"><span className="bold">Start </span> { start_date }</p>
              <StopButton stops={props.stops.length-1} stopsClicked={()=>this.openStopsModal()} />
            </li>
            <li>
              <p className="title">{props.data.passengers[0].reservations[props.data.passengers[0].reservations.length-1].end_city}</p>
              <p className="subtitle"><span className="bold">End </span>{ end_date }</p>
            </li>
          </ul>
        </div>
        <div className="column small-12 medium-5 description-box-item cyoa">

          <div className="row margin-b-10">
            <div className="column small-12">
              <p className="bold">Duration:</p>
              <p>{_numDays} days</p>
            </div>
          </div>

          <div className="row margin-b-10">
            <div className="column small-12">
              <p className="bold">Passengers:</p>
              <p>{ this.calculatePassengers(props.clients) }</p>
            </div>
          </div>

          <div className="row">
            <div className="column small-12 margin-b-10">
              <p className="bold">Accommodation:</p>
              <p>{_num_nights} nights</p>
            </div>
          </div>

        </div>
      </div>
    )
  }

  renderStopsModal(props){

    if(this.state.isCYOA){

      return (
        <ReactModal
          className="include-modal"
          overlayClassName="modal-overlay semi-white"
          isOpen={this.state.showStopsModal}
          onRequestClose={this.closeStopsModal}
          contentLabel="Stops modal">

          <div className="row">
             <div className="column small-12 stops-vertical">
               <ul>
               {
                 props.stops.map((list, i) => {

                  let duration = (i !== 0 && i < props.stops.length-1) ? dayjs(props.stops[i+1].date_for).diff(dayjs(props.stops[i].date_for), 'days') : "";
                  let label = duration !== "" ? (duration === 1) ? duration + ' day' : duration + ' days' : "";

                   return (
                     <li key={i}>
                      <p className="no-margin">{list.city}</p>
                      <p className="subtext no-margin">
                        <span className="orange-text">{i === 0 && 'Start'}</span>
                        {label}
                        <span className="orange-text">{i === props.stops.length - 1 && 'End'}</span>
                      </p>
                     </li>
                   )
                 })
               }
               </ul>
             </div>

             <div className="column small-12">
               <button className="modal-close orange" onClick={this.closeStopsModal}>
                 <span className="fa fa-times fa-lg"></span>
               </button>
             </div>
           </div>
        </ReactModal>
      )
    }else{
      return null;
    }
  }


  render(){

    const { product, data, currency, editlink, index, cyoaToken, itineraries, isRemoving } = this.props;

    const _editLink = !this.state.isCYOA ? `/basket/${data.tour_id}` : `${process.env.REACT_APP_WWW_BUILDER_URL}/itinerary/view?id=${cyoaToken}&v=itinerary`;
    const _product = (product !== "") ? product : "";
    const _itinerarySectors = (itineraries !== undefined) ? itineraries.sectors :  [];
    const _hasCyoa = (window.location.href.substring(window.location.href.lastIndexOf('/')+1) === 'cyoa') ? true : false;
    const _itineraryStatus = (itineraries !== undefined) ? itineraries.status :  [];
    const _itinerary = (itineraries !== undefined) ? itineraries : "";

    let imageObj = {
      imageQuality:60,
      mapHighlights:""
    }
    try{
      //check product type is fixed or hoho or cyo
      if(_filter(_product, ['tourId', data.tour_id ]).length === 0){
        imageObj.mapHighlights = _filter(_product[0].media, ['title', 'highlightImages'])[0].url;
      }else{
        imageObj.mapHighlights = ( _filter(_product, ['tourId', data.tour_id ])[0].media === undefined ) ? "" : _filter(_filter(_product, ['tourId', data.tour_id ])[0].media, {'title': 'highlightImages'})[0].url;
      }
    }catch(e){}

    const standardImg = () => {
      return (
        <img
          className="lazyload original"
          alt=""
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          data-sizes="auto"
          data-srcset={`https:${imageObj.mapHighlights}?w=150&q=${imageObj.imageQuality} 1x,
          https:${imageObj.mapHighlights}?w=300&q=${imageObj.imageQuality} 2x`} />
      )
    }

    const ieImg = () => {
      return (
        <img
          alt=""
          src={`https:${imageObj.mapHighlights}?w=150&q=${imageObj.imageQuality}`} />
      )
    }

  

    return (
     <React.Fragment>
       <div className="summary-edit" style={{"display":(editlink) ? "block": "none"}}>
         <div className="row">
          <div className="column small-12">
             <a href={_editLink} target="_self">
             <img src="https://images.contentful.com/3ng3kfj0qs70/61aInx7ERi8oWY2Qiiyks8/429ec7749141a2abdd1f96b229373204/icon-edit.svg" alt="edit icon"/>
             Edit trip
             </a>
           </div>
         </div>
      </div>

      <div className="summary-item">
        <div className="row">
          <div className="column small-12 medium-3 large-2 image-box hide-for-small-only hide-for-medium-only">

          { ieCheck() ? ieImg() : standardImg() }

          </div>
          <div className="column small-12 medium-8 large-6 description-box">
            <h5 className="orange-text">{data.tour_name}</h5>

            { (data.tour_id !== CYOA_NETWORK_IDS["europe"].id && data.tour_id !== CYOA_NETWORK_IDS["usa"].id ) ? this.renderStandardDescription(this.props) : this.renderCyoaDescription(this.props) }

          </div>

          <div className="column small-12 medium-4 large-4 trips-box">
            <div className="trip-box-container">
              <div className="row">
                <div className="column small-6 trips-box-left">
                  {
                    (_itineraryStatus !== "confirmed") ? (
                    <Fragment>
                      <p>Trip Price:</p>
                      <p className="bold">Subtotal (x {data.passengers.length}):</p>
                      <p className="viking-text" style={{display: (this.calculateDiscount(data.passengers) === "0.00") ? "none" : "block" }}>Discount:</p>
                      <p style={{display: (data.tour_id === CYOA_NETWORK_IDS["europe"].id || data.tour_id === CYOA_NETWORK_IDS["usa"].id) ? "block" : "none" }}>Accommodation:</p>
                      <p className="bold">Total Price:</p>
                      <button className="no-margin orange-text remove-trip-btn" style={{"display": (!_hasCyoa && index > 0 )? "block" : "none"}} onClick={this.onRemoveTrip}>Remove trip</button>
                    </Fragment> ) : (
                    <Fragment>
                      <p>Trip Total:</p>
                      <p>Total Paid:</p>
                      <p className="bold">Total Due:</p>
                    </Fragment>
                    )
                  }   
                </div>
                <div className="column small-6 trips-box-right">
                  {
                    (_itineraryStatus !== "confirmed") ? (
                      <Fragment>
                        <p>{currency}{ (data.passengers[0].price + data.passengers[0].discount).toFixed(2) }</p>
                        <p className="bold">{currency}{this.calculatePrice(data.passengers)}</p>
                        <p className="viking-text" style={{display: (this.calculateDiscount(data.passengers) === "0.00") ? "none" : "inline-block" }}>-{currency}{this.calculateDiscount(data.passengers)}
                          <span className="ba-icon ba_icon_extra_info_alt" onClick={this.discountClick} style={{"display":(this.discountMsg(data.passengers) !== "")? 'inline-block': 'none'}}></span>
                        </p>
                        <p style={{display: (data.tour_id === CYOA_NETWORK_IDS["europe"].id || data.tour_id === CYOA_NETWORK_IDS["usa"].id) ? "block" : "none" }}>{currency}{calculateAccommodationPrice(_itinerarySectors)}</p>
                        <p className="bold">{currency}{this.calculateTotal(data)}</p>
                      </Fragment>) : (
                      <Fragment>
                        <p>{currency}{(parseFloat(_itinerary.total) + parseFloat(_itinerary.accomm_total)).toFixed(2) }</p>
                        <p>{currency}{_itinerary.total_paid}</p>
                        <p className="bold">{currency}{_itinerary.grand_total}</p>
                      </Fragment>
                    )
                  }
                </div>
              </div>
            </div>

              <div className="discount-tooltip" style={{"display":(this.state.discountTooltipIsOpen) ? "block": "none"}} >{this.discountMsg(data.passengers)}</div>
          </div>

          <div className="summary-loading" style={{display: (isRemoving && index == 1)  ? 'block' : 'none' }}>
            <div className="column small-12">
              <Spinner text="Removing trip..." loadClass="loading-spinner" />
            </div>
          </div>

        </div>
      </div>


      { this.renderStopsModal(this.props) }

    </React.Fragment>

  )}

}

function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data,
    bookingGroup:state.bookingGroup.data,
    isRemoving:state.bookingGroup.removing
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    DeleteTrip
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(SummaryItem);



// WEBPACK FOOTER //
// ./src/components/shared/summaryitem.js